import {useEffect, useRef} from "react";
import styled from "styled-components";
import {loadGoogleMaps} from "../../../../utils/google-maps-loader";

const StyledMapContainer = styled.div`
  width: 100%;
  height: 24rem;
  margin-top: 1.2rem;
  border-radius: 8px;
  overflow: hidden;
`;

interface LocationMapProps {
  lat: number;
  lng: number;
}

export function LocationMap({lat, lng}: LocationMapProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<google.maps.Map | null>(null);
  const markerRef = useRef<google.maps.Marker | null>(null);

  useEffect(() => {
    let cancelled = false;

    loadGoogleMaps()
      .then((googleNamespace) => {
        if (cancelled || !containerRef.current) {
          return;
        }

        const position = {lat, lng};

        if (!mapRef.current) {
          mapRef.current = new googleNamespace.maps.Map(containerRef.current, {
            center: position,
            zoom: 15,
          });
          markerRef.current = new googleNamespace.maps.Marker({
            position,
            map: mapRef.current,
          });
          return;
        }

        mapRef.current.setCenter(position);
        markerRef.current?.setPosition(position);
      })
      .catch((error) => {
        console.error("Failed to load Google Maps:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [lat, lng]);

  return <StyledMapContainer ref={containerRef} />;
}
